import {Component, OnInit} from '@angular/core';
import {MatDialogRef} from '@angular/material/dialog';
import {SiteDetailsService} from '../../../services/site-details.service';
import {MySitesService} from '../../../services/my-sites.service';
import {SaveTuningsAndAddonsChangesService} from '../../../services/save-tunings-and-addons-changes.service';
import {SUBSCRIPTIONS} from '../../../common/utils/constants';
import {AutoUnsubscribe} from '../../../decorators/auto-unsubscribe.decorator';
import {UserPermissions} from '../../../common/elf-store/user-permissions/user-permissions.store';

@Component({
  selector: 'mc-save-changes-modal',
  templateUrl: './save-changes-modal.component.html',
  styleUrl: './save-changes-modal.component.scss',
})
@AutoUnsubscribe()
export class SaveChangesModalComponent implements OnInit {
  constructor(
    private dialogRef: MatDialogRef<SaveChangesModalComponent>,
    private siteDetailsService: SiteDetailsService,
    private readonly sitesService: MySitesService,
    public saveTuningsAndAddonsChangesService: SaveTuningsAndAddonsChangesService,
  ) {}

  ngOnInit(): void {
    this[SUBSCRIPTIONS].add(
      this.saveTuningsAndAddonsChangesService.confirmDialogEmitter.subscribe(() => {
        this.closeDialog();
      }),
      this.dialogRef.afterClosed().subscribe(event => {
        if (event === undefined) {
          this.backToSelectedTab();
        }
      }),
    );
  }

  get UserPermissions() {
    return UserPermissions;
  }

  closeDialog(stayOnSameRoute: boolean = false): void {
    if (stayOnSameRoute) {
      this.backToSelectedTab();
    }
    this.dialogRef.close(stayOnSameRoute);
  }

  save(isGlobal: boolean = false): void {
    if (isGlobal) {
      this.saveTuningsAndAddonsChangesService.saveUpdatedTuningsAddonsDataAllSites();
    } else {
      this.saveTuningsAndAddonsChangesService.saveUpdatedTuningsAddonsData();
    }
  }

  discard(): void {
    this.saveTuningsAndAddonsChangesService.discard();
    this.closeDialog(false);
  }

  backToSelectedTab(): void {
    this.siteDetailsService.selectedTab$.next(this.siteDetailsService.selectedTab$.value);
  }

  get sitesListCount(): number {
    return this.sitesService.mySitesList?.length;
  }
}
